import React, { useCallback, useEffect, useState, useRef } from "react";
import uncodedIcon from "../../../common/assets/images/uncoded.png";
import unassignedIcon from "../../../common/assets/images/unassigned.png";
import overDueIcon from "../../../common/assets/images/overdue.png";
import inprogressIcon from "../../../common/assets/images/inprogress.png";
import backIcon from "../../../common/assets/images/back-icon.png";
import userIcon from "../../../common/assets/images/user-icon.png";
import generalsurgeryIcon from "../../../common/assets/images/general-surgery-icon.png";
import workflowFilterIcon from "../../../common/assets/images/workflow-filter-icon.png";
import LdsRoller from "../../../utils/LdsRoller";
import closeIcon from "../../../common/assets/images/modal-close-icon.png";
import { toast, ToastContainer } from "react-toastify";
import {
  Table,
  Badge,
  Form,
  Pagination,
  Dropdown,
  Button,
  Card,
  Placeholder,
  Spinner,
} from "react-bootstrap";
import "./HealthInformationManager.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatCalenderDate } from "../../CodingScreen/utils";
import { Tooltip } from "@mui/material";
import {
  getHealthInformationQueueManagerData,
  getHealthInsuranceManagerFilterOptions,
  specialityOptions,
  queueOptions,
  usersOptions,
  updateFilters,
  updateSpecialityPageNumber,
  updateQueuePageNumber,
  updateUserPageNumber,
  updateComponentState,
  resetEpisodeAssignmentMessage,
} from "./redux/HealthInsuranceManagerSlicer";
import { useDispatch, useSelector } from "react-redux";
import HealthInformationManagerAssignModal from "./HealthInformationManagerAssignModal";
import { debounce } from "lodash";
import search_icon from "../../../common/assets/images/search-icon-new.png";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import HealthSideDrawer from "./mobile/HealthSideDrawer";

const HealthInformationManager = () => {
  // declaration
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const dispatch = useDispatch();
  const dateFormat = "dd-MM-yyyy";
  const appliedFiltersRef = useRef();
  const navigate = useNavigate();
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

  // selectors
  const {
    healthInsuranceManagerFiltersPriority,
    healthInsuranceManagerFiltersStatus,
  } = useSelector(
    (state) => state.healthInsuranceManager.healthInsuranceManagerFilters
  );
  const {
    specialityPageNumber,
    specialityData,
    specialityLoading,
    specialityError,
    isSpecialityPageTrue,
  } = useSelector((state) => state.healthInsuranceManager.speciality);
  const {
    usersPageNumber,
    usersData,
    usersLoading,
    usersError,
    isUserPageTrue,
  } = useSelector((state) => state.healthInsuranceManager.users);
  const {
    queuePageNumber,
    queueData,
    queueLoading,
    queueError,
    isQueuePageTrue,
  } = useSelector((state) => state.healthInsuranceManager.queue);
  const filtersPayload = useSelector(
    (state) =>
      state.healthInsuranceManager.healthInsuranceManagerEpisodesPayload
  );
  const { episodeAssignmentPayload } = useSelector(
    (state) => state.healthInsuranceManager
  );
  const { episodeAssignmentResponse } = useSelector(
    (state) => state.healthInsuranceManager.healthInsuranceManagerAssignment
  );
  const {
    healthInsuranceManagerData,
    healthInsuranceManagerDataLoading,
    healthInsuranceManagerDataError,
  } = useSelector(
    (state) => state.healthInsuranceManager.healthInsuranceManagerResponse
  );
  // states
  const { selectedRecord } = useSelector(
    (state) => state.healthInsuranceManager.healthInsuranceManagerComponentState
  );
  const [episodesCurrentPage, setEpisodesCurrentPage] = useState(1);
  const isTouchDevice =
    typeof window !== "undefined" &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0);

  // const [filterEpisodes, setFilterEpisodes] = useState({
  //   separation_date_from: null,
  //   separation_date_to: null,
  //   speciality: [],
  //   queue: [],
  //   queue_priority: [],
  //   status: [],
  //   coders: [],
  //   // page_number: episodesCurrentPage,
  // });
  const [workflowHimsAssginModal, setWorkflowHimsAssginModal] = useState(false);
  const [episodesPerPage, setEpisodesPerPage] = useState(10);
  const [selectedHimEpisodes, setSelectedHimEpisodes] = useState([]);
  const [isAllEpisodesSelected, setIsAllEpisodesSelected] = useState(false);
  // const [selectedRecord, setSelectedRecord] = useState({});
  const [showFilterSection, setShowFilterSection] = useState(true);
  const [appliedFilterModal, setAppliedFilterModal] = useState(false);
  const [episodesData, setEpisodesData] = useState([]);
  const [specialitySearchValue, setSpecialitySearchValue] = useState("");
  const [currentQueueSearchValue, setCurrentQueueSearchValue] = useState("");
  const [codersSearchValue, setCodersSearchValue] = useState("");
  const [prioritySearchValue, setPrioritySearchValue] = useState("");
  const [statusSearchValue, setStatusSearchValue] = useState("");
  const [uncheckedIds, setUncheckedIds] = useState([]);
  // const totalPages = episodesPerPage > 0 ? Math.ceil(episodesData?.length / episodesPerPage) : 0;
  const totalPages =
    typeof healthInsuranceManagerData?.meta?.meta?.total_episodes ===
      "number" &&
    typeof filtersPayload?.page_size === "number" &&
    filtersPayload.page_size > 0
      ? Math.ceil(
          healthInsuranceManagerData?.meta?.meta?.total_episodes /
            filtersPayload.page_size
        )
      : 0;
  // const indexOfLastEpisode = episodesCurrentPage * episodesPerPage;
  // const indexOfFirstEpisode = indexOfLastEpisode - episodesPerPage;
  // const currentEpisodesList = episodesData?.slice(indexOfFirstEpisode, indexOfLastEpisode);
  const dataToDisplay = episodesData?.length > 0 && episodesData;
  const codingDashboardOptions =
    healthInsuranceManagerData?.cards &&
    Object.keys(healthInsuranceManagerData?.cards)?.map((item) => {
      return {
        name:
          item === "uncoded"
            ? "Uncoded"
            : item === "unassigned"
            ? "Unassigned"
            : item === "overdue"
            ? "Overdue"
            : item === "in_progress"
            ? "Inprogess"
            : "",
        // count:item === "uncoded" ? apiResponse.episodes.filter((ep) => ep === "uncoded").length : item === "unassigned" ? apiResponse.episodes.filter((ep) => ep === "unassigned").length : item === "overdue" ? apiResponse.episodes.filter((ep) => ep === "overdue").length : item === "in_progress" ? apiResponse.episodes.filter((ep) => ep === "in_progress").length : 0,
        count: healthInsuranceManagerData.cards[item],
        // count: item === "uncoded" ? "256" : item === "unassigned" ? "196" : item === "overdue" ? "2" : item === "In progress" ? "65" : "0",
        icon:
          item === "uncoded"
            ? uncodedIcon
            : item === "unassigned"
            ? unassignedIcon
            : item === "overdue"
            ? overDueIcon
            : item === "in_progress"
            ? inprogressIcon
            : "",
        tooltipContent:
          item === "uncoded"
            ? "You have 10 uncoded episodes awaiting coding"
            : item === "unassigned"
            ? "You have 10 unassigned episodes pending allocation"
            : item === "overdue"
            ? "You have 10 episodes that are overdue for completion"
            : item === "in_progress"
            ? "You have 10 ongoing episodes in progress"
            : "",
        backgroundColor:
          item === "uncoded"
            ? "#EFF6FF"
            : item === "unassigned"
            ? "#FEF2F2"
            : item === "overdue"
            ? "#FEFCE8"
            : item === "in_progress"
            ? "#ECFDF5"
            : "",
      };
    });

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      const payload = {
        ...filtersPayload,
        page_number: pageNumber,
      };
      dispatch(getHealthInformationQueueManagerData(payload));
      dispatch(updateFilters(payload));
      // setEpisodesCurrentPage(pageNumber);
    }
  };

  const handleRowsPerPageChange = (event) => {
    const payload = {
      ...filtersPayload,
      page_number: 1,
      page_size: Number(event.target.value),
    };
    dispatch(getHealthInformationQueueManagerData(payload));
    dispatch(updateFilters(payload));
    // setEpisodesCurrentPage(1);
    // setEpisodesPerPage(Number(event.target.value));
  };

  const hanldeSelectAllHimEpisodes = (event) => {
    const allSelectedEpisodes = episodesData?.map((item) => item);
    if (event && event.target.checked) {
      setSelectedHimEpisodes(allSelectedEpisodes);
      setUncheckedIds([]);
      setIsAllEpisodesSelected(true);
    } else {
      setSelectedHimEpisodes([]);
      setIsAllEpisodesSelected(false);
    }
  };

  useEffect(() => {
    if (isAllEpisodesSelected && episodesData?.length > 0) {
      const newSelected = episodesData.filter(
        (item) => !uncheckedIds.includes(item.hcp_line_id)
      );

      const uniqueSelected = [
        ...selectedHimEpisodes,
        ...newSelected.filter(
          (item) =>
            !selectedHimEpisodes.some((s) => s.hcp_line_id === item.hcp_line_id)
        ),
      ];

      setSelectedHimEpisodes(uniqueSelected);
    }
  }, [episodesData, isAllEpisodesSelected, uncheckedIds]);

  // const handleHimRowSelection = (event, HimEpisodeItem) => {
  //   dispatch(updateComponentState(HimEpisodeItem))
  //   // setSelectedRecord(HimEpisodeItem)
  //   if (event.target.checked) {
  //     const selectedData = [...selectedHimEpisodes, HimEpisodeItem?.hcp_line_id];
  //     setSelectedHimEpisodes(selectedData);
  //   } else {
  //     if(isAllEpisodesSelected){
  //       const newUnassignedData = selectedHimEpisodes.filter(
  //         (epsoideId) => epsoideId === HimEpisodeItem?.hcp_line_id
  //       );
  //       console.log(newUnassignedData, 'newUnassignedData')
  //     }

  //     const newAssignedData = selectedHimEpisodes.filter(
  //       (epsoideId) => epsoideId !== HimEpisodeItem?.hcp_line_id
  //     );
  //     setSelectedHimEpisodes(newAssignedData);
  //   }
  // };

  const handleHimRowSelection = (event, HimEpisodeItem) => {
    dispatch(updateComponentState(HimEpisodeItem));
    if (event.target.checked) {
      const selectedData = [...selectedHimEpisodes, HimEpisodeItem];
      setSelectedHimEpisodes(selectedData);
      // setUncheckedIds(uncheckedIds.filter(id => id !== HimEpisodeItem?.hcp_line_id));
    } else {
      if (isAllEpisodesSelected) {
        const newUnassignedData = selectedHimEpisodes.filter(
          (episodeId) => episodeId?.hcp_line_id === HimEpisodeItem?.hcp_line_id
        );
        setUncheckedIds([...uncheckedIds, HimEpisodeItem?.hcp_line_id]);
      }
      const newAssignedData = selectedHimEpisodes.filter(
        (episodeId) => episodeId?.hcp_line_id !== HimEpisodeItem?.hcp_line_id
      );
      setSelectedHimEpisodes(newAssignedData);
    }
  };

  // const handleHimSelectChange = (fieldName, value) => {
  //   const currentValues = filtersPayload[fieldName] || [];

  //   const updatedValues = currentValues.includes(value)
  //     ? currentValues.filter((item) => item !== value)
  //     : [...currentValues, value];
  //   console.log(updatedValues, )
  //   const updatedFilters = {
  //     ...filtersPayload,
  //     [fieldName]: updatedValues,
  //   };

  //   dispatch(getHealthInsuranceManagerData(updatedFilters))
  //   applyFilters(updatedFilters);

  //   // setFilterEpisodes(updatedFilters);
  // };

  const handleHimSelectChange = (fieldName, value) => {
    const currentValues = filtersPayload[fieldName] || [];
    let updatedValues = [];

    if (Array.isArray(value)) {
      updatedValues = value;
    } else {
      updatedValues = currentValues.includes(value)
        ? currentValues.filter((item) => item !== value)
        : [...currentValues, value];
    }

    const updatedFilters = {
      ...filtersPayload,
      page_number: 1,
      [fieldName]: updatedValues,
    };
    dispatch(updateFilters(updatedFilters));
    dispatch(getHealthInformationQueueManagerData(updatedFilters));
    // setFilterEpisodes(updatedFilters);
    // applyFilters(updatedFilters); // Consider if you want to apply filters immediately
  };

  // const applyFilters = (filters) => {
  //   console.log(filters, 'filters')
  //   const noFiltersApplied = Object.values(filters).every(
  //     (val) => !val || val.length === 0
  //   );

  //   if (noFiltersApplied) {
  //     setEpisodesData(episodesData);
  //     return;
  //   }
  //   let filteredData = [...episodesData];
  //   const filterConditions = {
  //     speciality: (item) =>
  //       !filters.speciality ||
  //       filters.speciality.length === 0 ||
  //       filters.speciality.includes(item.speciality),

  //     queue_priority: (item) =>
  //       !filters.queue_priority ||
  //       filters.queue_priority.length === 0 ||
  //       filters.queue_priority.includes(item.priority),

  //     queue: (item) =>
  //       !filters.queue ||
  //       filters.queue.length === 0 ||
  //       filters.queue.includes(item.queue),

  //     status: (item) =>
  //       !filters.status ||
  //       filters.status.length === 0 ||
  //       filters.status.includes(item.status),

  //     coders: (item) =>
  //       !filters.coders ||
  //       filters.coders.length === 0 ||
  //       filters.coders.includes(item.coders),
  //   };

  //   filteredData = filteredData.filter((item) =>
  //     Object.values(filterConditions).every((condition) => condition(item))
  //   );
  //   // dispatch(getHealthInsuranceManagerData(filtersPayload))
  //   // setEpisodesData(filteredData);
  // };

  const handleHimDatePickerChange = (fieldName, date) => {
    let filteredData = episodesData;

    const updatedFilters = {
      ...filtersPayload,
      page_number: 1,
      [fieldName === fieldName ? fieldName : fieldName]:
        formatCalenderDate(date),
    };

    if (updatedFilters.separation_date_from) {
      filteredData = filteredData.filter(
        (item) =>
          item.separation_date_from === updatedFilters.separation_date_from
      );
    }

    if (updatedFilters.separation_date_to) {
      filteredData = filteredData.filter(
        (item) => item.separation_date_to === updatedFilters.separation_date_to
      );
    }
    dispatch(updateFilters(updatedFilters));
    dispatch(getHealthInformationQueueManagerData(updatedFilters));
    // setFilterEpisodes(updatedFilters);
    // setEpisodesData(filteredData);
  };

  const hanldeSelectQueueEpisodes = (type, data) => {
    if (type === "queue") {
      const payload = {
        ...filtersPayload,
        page_number: 1,
        coders: [],
        queue: [data.queue_id],
      };
      setSelectedHimEpisodes([]);
      dispatch(updateFilters(payload));
      dispatch(getHealthInformationQueueManagerData(payload));
    }

    if (type === "coder") {
      const payload = {
        ...filtersPayload,
        page_number: 1,
        queue: [],
        coders: [data.coder_id],
      };
      setSelectedHimEpisodes([]);
      dispatch(updateFilters(payload));
      dispatch(getHealthInformationQueueManagerData(payload));
    }

    // if (queueData.queue_name === "Cardiology")
    //   setEpisodesData(apiResponse.episodes);
    // if (queueData.queue_name === "Orthopaedics")
    //   setEpisodesData(queueOrthopaedicsData);
    // if (queueData.queue_name === "Respiratory") {
    //   setEpisodesData(queueRespiratoryData);
    // }
  };

  const renderDropdownOptions = (type, options, selected, searchValue) => {
    return options
      ?.filter((item) => item.toLowerCase().includes(searchValue.toLowerCase()))
      .map((item) => (
        <Form.Check
          key={item}
          type="checkbox"
          className="workflow-him-dropdown-menu-options"
          label={item}
          value={item}
          checked={selected?.includes(item)}
          onChange={() => handleHimSelectChange(type, item)}
        />
      ));
  };

  const handleDragStart = (e, item) => {
    e.dataTransfer.setData("application/json", JSON.stringify(item));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, selectedName, type) => {
    e.preventDefault();
    const item = JSON.parse(e.dataTransfer.getData("application/json"));
    setWorkflowHimsAssginModal(true);
    let selectedEpisodeToTransfer = {};
    if (type === "queues") {
      selectedEpisodeToTransfer = { ...item, queue: selectedName };
    }
    if (type === "coders") {
      selectedEpisodeToTransfer = { ...item, assigned_user: selectedName };
    }
    dispatch(updateComponentState(selectedEpisodeToTransfer));
    // setSelectedRecord(selectedEpisodeToTransfer);
    // setSelectedRecord(item)
    // setCards((prevCards) => {
    //   const card = prevCards[cardKey];
    //   if (card.items.includes(item)) return prevCards;

    //   return {
    //     ...prevCards,
    //     [cardKey]: {
    //       ...card,
    //       items: [...card.items, item]
    //     }
    //   };
    // });
  };

  const handleFilterRemove = (filterName, item) => {
    const updatedFilterObj = { ...filtersPayload };
    if (Array.isArray(updatedFilterObj[filterName])) {
      updatedFilterObj[filterName] = updatedFilterObj[filterName].filter(
        (value) => value !== item
      );
    } else {
      updatedFilterObj[filterName] = filterName === "date" ? null : "";
    }
    dispatch(updateFilters(updatedFilterObj));
    dispatch(getHealthInformationQueueManagerData(updatedFilterObj));
    // setFilterEpisodes(updatedFilterObj);
  };

  const keysToRemove = ["page_number", "page_size"];
  const newObj = { ...filtersPayload };
  keysToRemove.forEach((key) => {
    delete newObj[key];
  });
  const hasValue = Object.values(newObj).some(
    (item) =>
      item !== "" &&
      item !== null &&
      (Array.isArray(item) ? item.length > 0 : true)
  );

  const handleReset = () => {
    const resetState = {
      separation_date_from: null,
      separation_date_to: null,
      speciality: [],
      queue: [],
      queue_priority: [],
      status: [],
      coders: [],
      episode_identifier_search: "",
    };
    dispatch(updateFilters(resetState));
    dispatch(getHealthInformationQueueManagerData(resetState));
    // setFilterEpisodes(resetState);
  };

  useEffect(() => {
    dispatch(getHealthInsuranceManagerFilterOptions());
    dispatch(getHealthInformationQueueManagerData(filtersPayload));
  }, []);

  useEffect(() => {
    if (isQueuePageTrue && !queueLoading) {
      dispatch(updateQueuePageNumber(queuePageNumber + 1));
      dispatch(queueOptions(queuePageNumber + 1));
    }
  }, [isQueuePageTrue, queueLoading]);

  useEffect(() => {
    if (isSpecialityPageTrue && !specialityLoading) {
      dispatch(updateSpecialityPageNumber(specialityPageNumber + 1));
      dispatch(specialityOptions(specialityPageNumber + 1));
    }
  }, [isSpecialityPageTrue, specialityLoading]);

  useEffect(() => {
    if (isUserPageTrue && !usersLoading) {
      dispatch(updateUserPageNumber(usersPageNumber + 1));
      dispatch(usersOptions(usersPageNumber + 1));
    }
  }, [isUserPageTrue, usersLoading]);

  useEffect(() => {
    setEpisodesData(healthInsuranceManagerData.episodes);
  }, [healthInsuranceManagerData]);

  useEffect(() => {
    if (episodeAssignmentResponse.message) {
      toast.success("Assigned episodes successfully");
      const resetState = {
        separation_date_from: null,
        separation_date_to: null,
        speciality: [],
        queue: [],
        queue_priority: [],
        status: [],
        coders: [],
        page_number: 1,
        page_size: 10,
        episode_identifier_search: "",
      };
      dispatch(getHealthInformationQueueManagerData(resetState));
      dispatch(updateFilters(resetState));
      setSelectedHimEpisodes([]);
      setIsAllEpisodesSelected(false);
      setWorkflowHimsAssginModal(false);
    }
    // dispatch(updateComponentState({}))
    dispatch(resetEpisodeAssignmentMessage());
  }, [episodeAssignmentResponse]);

  const getValueFromApi = (key, itemId) => {
    console.log(key, "key");
    if (key === "queue") {
      const queues = queueData || [];
      const matchedQueue = queues.find((q) => q?.queue_id === itemId);
      return matchedQueue?.queue_name || itemId;
    } else if (key === "coders") {
      const users = usersData || [];
      const matchedUser = users.find((u) => u?.user_id === itemId);
      return matchedUser?.user_name || itemId;
    }
    return itemId;
  };

  const debounceSearchHandler = useCallback(
    debounce((payload) => {
      dispatch(getHealthInformationQueueManagerData(payload));
    }, 1000),
    []
  );

  const handleSearchEpisode = (e) => {
    const payload = {
      ...filtersPayload,
      episode_identifier_search:
        e?.target?.value?.length > 0 ? e?.target?.value : "",
    };
    dispatch(updateFilters(payload));
    // dispatch(getHealthInformationQueueManagerData(payload))
    debounceSearchHandler(payload);
    // if (e?.target?.value?.trim() === "") {
    //   setEpisodeIdentifierSearchModal(false);
    // }
  };

  // const handleEpisodeIdentifier = (episodeIdentifier) => {
  //    const payload = {
  //         ...filtersPayload,
  //         episode_identifier_search: episodeIdentifier,
  //       }
  //       dispatch(getHealthInformationQueueManagerData(payload))
  // }

  const getHighlightedText = (text) => {
    const fullText = text || "";
    const search = filtersPayload?.episode_identifier_search || "";

    const index = fullText?.toLowerCase()?.indexOf(search?.toLowerCase());

    if (index === -1 || !search) {
      return fullText;
    }

    const before = fullText?.slice(0, index);
    const match = fullText?.slice(index, index + search?.length);
    const after = fullText?.slice(index + search.length);

    return (
      <>
        {before}
        <span style={{ backgroundColor: "yellow" }}>{match}</span>
        {after}
      </>
    );
  };

  useEffect(() => {
    if (appliedFilterModal) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [appliedFilterModal]);
  useEffect(() => {
    dispatch(getHealthInformationManagerQueuesData({
        screen_type: storedRole === "coder" ? "U" : "AU",
    }));
    // dispatch(
    //   getHealthInformationManagerUsersData({
    //     screen_type: storedRole === "coder" ? "U" : "AU",
    //     page_number: sideBarUsersDatapageNumber + 1,
    //     limit: 10,
    //   }),
    // );
    return () => {
      toast.dismiss();
    };
  }, []);
  const handleScroll = (e) => {
    console.log("aSDFGDSEAwasdfgd");

    const { scrollTop, scrollHeight, clientHeight } = e.target;

    // Check if scrollbar exists
    const hasScrollbar = scrollHeight > clientHeight;
    console.log("triggered", hasScrollbar);

    if (!hasScrollbar) return;

    // Trigger only when reaching bottom
    if (scrollHeight - scrollTop <= clientHeight + 100) {
      console.log("triggered");

      if (sideBarUsersDatahasMore && !sideBarUsersDataLoading) {
        dispatch(
          getHealthInformationManagerUsersData({
            screen_type: storedRole === "coder" ? "U" : "AU",
            page_number: sideBarUsersDatapageNumber + 1,
            limit: 10,
          }),
        );
      }
    }
  };


useEffect(() => {
  const el = codersContainerRef.current;
  if (!el) return;
  const hasScrollbar = el.scrollHeight >= el.clientHeight;
    
  if (
    hasScrollbar &&
    sideBarUsersDatahasMore &&
    !sideBarUsersDataLoading
  ) {

    dispatch(
      getHealthInformationManagerUsersData({
        screen_type: storedRole === "coder" ? "U" : "AU",
        page_number: sideBarUsersDatapageNumber + 1,
        limit: 10,
      })
    );
  }
}, [
  sideBarCodersData,
  sideBarUsersDatahasMore,
  sideBarUsersDataLoading,
  sideBarUsersDatapageNumber,
  storedRole,
  dispatch,
]);



  const handleClickOutside = (event) => {
    if (
      appliedFiltersRef.current &&
      !appliedFiltersRef.current.contains(event.target)
    ) {
      setAppliedFilterModal(false);
    }
  };


  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="workflow-him-container">
        {!isMobile && (
          <div lg="3" sm="12" xs="12" md="12" className="left-him-workflow-card">
            <div className="left-him-workflow-card-header">
              <img src={backIcon} className="left-him-workflow-card-icon"
                onClick={() => navigate('/Code-Workflow')}
              />
              <p className="left-him-workflow-card-text">Back to Workflow</p>
            </div>
            <div className="left-him-workflow-queues-card">
              <div className="him-queues-sections">
                <p className="left-him-workflow-queues-card-header">Queues</p>
                <div className="him-workflow-queues-container">
                  {healthInsuranceManagerDataLoading ?
                    <div className="left-him-workflow-queues-card-top">
                      {/* <LdsRoller/>  */}
                      <div style={{ width: "100%", minHeight: "300px" }}>
                        <Placeholder animation="glow">
                          <Placeholder xs={12} className="queuePlaceholder" />
                        </Placeholder>
                      </div>
                    </div>
                    : healthInsuranceManagerDataError ? <div className="left-him-workflow-queues-error"> No queues found  </div> :
                      healthInsuranceManagerData?.queues?.map((queriesItem) => (
                        <div
                          className="left-him-workflow-queues-card-top"
                          key={queriesItem?.queue_id}
                          onDragOver={handleDragOver}
                          onDrop={(e) => handleDrop(e, queriesItem?.queue_name, 'queues')}
                          onClick={() => hanldeSelectQueueEpisodes('queue', queriesItem)}
                        >
                          <p className="left-him-workflow-queues-card-icon">
                            <img src={generalsurgeryIcon} alt={queriesItem?.queue_id} />
                          </p>
                          <p className="left-him-workflow-queues-card-name">
                            {queriesItem?.queue_name?.length > 20 ? (
                              <Tooltip title={queriesItem?.queue_name}>
                                {`${queriesItem?.queue_name[0]?.toUpperCase()}${queriesItem?.queue_name?.slice(1, 20)}...`}
                              </Tooltip>
                            ) : (
                              `${queriesItem?.queue_name[0]?.toUpperCase()}${queriesItem?.queue_name?.slice(1)}`
                            )}
                          </p>
                          <p className="left-him-workflow-queues-card-count">
                            <Tooltip title={`Yet to be assigned: ${queriesItem?.number_of_episodes}, Total records: ${queriesItem?.total_number_of_episodes}`}>
                              {`( ${queriesItem?.number_of_episodes} / ${queriesItem?.total_number_of_episodes})`}
                              {/* <FontAwesomeIcon icon={faCircleInfo}  className="him-dashboard-tooltip"/> */}
                            </Tooltip>
                          </p>
                        </div>
                      ))}
                </div>
              </div>
              <div className="him-coders-sections">

                <p className="left-him-workflow-coders-card-header"> Coders </p>
                <div className="him-workflow-coders-container">

                  {healthInsuranceManagerDataLoading ?
                    <div className="left-him-workflow-coders-card-top">
                      {/* <LdsRoller/>  */}
                      <div className="" style={{ width: "100%", minHeight: "300px" }}>
                        <Placeholder animation="glow">
                          <Placeholder xs={12} className="queuePlaceholder" />
                        </Placeholder>
                      </div>
                    </div> : healthInsuranceManagerDataError ? <div className="left-him-workflow-coders-error"> No coders found </div> :
                      healthInsuranceManagerData?.coders?.map((codersItem) => (
                        <div
                          className="left-him-workflow-coders-card-top" key={codersItem?.coder_id}
                          onDragOver={handleDragOver}
                          onDrop={(e) => handleDrop(e, codersItem?.coder_name, 'coders')}
                          onClick={() => hanldeSelectQueueEpisodes('coder', codersItem)}
                        >
                          <p className="left-him-workflow-coders-card-icon">
                            <img src={userIcon} alt={codersItem?.coder_name} />
                          </p>
                          <p className="left-him-workflow-coders-card-name">
                            {`${codersItem?.coder_name?.slice(0, 1)?.toUpperCase()}${codersItem?.coder_name?.slice(1)}`}
                          </p>
                          <p className="left-him-workflow-coders-card-count">
                            <Tooltip className="him-dashboard-tooltip" title={`${codersItem?.number_of_episodes} Coders Assigned`}>
                              {`( ${codersItem?.number_of_episodes} )`}
                              {/* <FontAwesomeIcon icon={faCircleInfo}  /> */}
                            </Tooltip>
                          </p>
                        </div>
                      )
                      )}
                </div>
              </div>

            </div>
          </div>
        )}
        <div className="right-him-workflow-card">
          {isMobile && (
            <div className="mobile-qc-header">
              <img
                src={backIcon}
                alt="back"
                className="mobile-qc-back-icon"
                onClick={() => navigate("/Code-Workflow")}
              />
              <span className="mobile-qc-back-text">Back to Workflow</span>
            </div>
          )}
          <div className="him-dashboard">
            {healthInsuranceManagerDataLoading ? (
              <Placeholder as={Card.Text} animation="glow" style={{ width: "100%" }}>
                <Placeholder xs={4} className="PlaceholderItem" /> <Placeholder xs={4} className="PlaceholderItem" /> <Placeholder xs={3} className="PlaceholderItem" />
              </Placeholder>
            ) : (
              // <LdsRoller/> 
              codingDashboardOptions?.length > 0 &&
              codingDashboardOptions?.map((dashboardItem) => (
                <div
                  key={dashboardItem?.name}
                  className="him-dashboard-cards"
                  style={{ backgroundColor: dashboardItem?.backgroundColor }}
                >
                  <div className="him-dashboard-cards-top">
                    <p className="him-dashboard-name">
                      {dashboardItem?.name}
                      {/* <Tooltip title={dashboardItem.tooltipContent}>
                      <FontAwesomeIcon icon={faCircleInfo}  className="him-dashboard-tooltip"/>
                    </Tooltip> */}
                    </p>
                    <p className="him-dashboard-icon">
                      <img
                        src={dashboardItem?.icon}
                        alt={dashboardItem?.name}
                      />
                    </p>
                  </div>
                  <p className="him-dashboard-count">{dashboardItem?.count}</p>
                </div>
              ))
            )}
          </div>
          {isMobile && (
            <div className="mobile-view-filter">
              <HealthSideDrawer
                healthInsuranceManagerData={healthInsuranceManagerData}
                healthInsuranceManagerDataLoading={healthInsuranceManagerDataLoading}
                healthInsuranceManagerDataError={healthInsuranceManagerDataError}
                handleDragOver={handleDragOver}
                handleDrop={handleDrop}
                hanldeSelectQueueEpisodes={hanldeSelectQueueEpisodes}
              />  </div>
          )}
          <div
            className={
              showFilterSection
                ? "workflow-him-main-container-open"
                : "workflow-him-main-container-close"
            }
          >
            <div className="workflow-him-main-container-top">
              <p className="workflow-him-main-container-name">Filters</p>
              <div>
                {hasValue && (
                  <Button
                    className="workflow-him-applied-filter-btn"
                    onClick={() => setAppliedFilterModal(!appliedFilterModal)}
                  >
                    Applied Filter
                  </Button>
                )}
                <span
                  className="workflow-him-main-container-icon"
                  onClick={() => setShowFilterSection(!showFilterSection)}
                >
                  <img src={workflowFilterIcon} alt="" />
                </span>
              </div>
            </div>
            <>
              {/* <div className="workflow-him-filter-section"> */}
              {appliedFilterModal && hasValue && (
                <div
                  className="workflow-him-filter-breadcrumb-section"
                  ref={appliedFiltersRef}
                >
                  <div className="workflow-him-filter-breadcrumb-list">
                    <p className="workflow-him-applied-header">
                      Applied Filters
                    </p>
                    {Object.keys(filtersPayload).map((key) => {
                      const value = filtersPayload[key];
                      if (
                        key === "separation_date_from" ||
                        key === "separation_date_to"
                      ) {
                        return (
                          value && (
                            <Badge
                              key={key}
                              bg="light"
                              text="dark"
                              className="workflow-him-filter-breadcrumbItem"
                            >
                              <span>
                                {key === "separation_date_from"
                                  ? "Separation Date From"
                                  : "Separation Date To"}{" "}
                                : {new Date(value).toLocaleDateString()}
                              </span>
                              <img
                                src={closeIcon}
                                height="15px"
                                width="15px"
                                onClick={() => handleFilterRemove(key)}
                                className="workflow-him-filter-close-icon"
                                alt={`Remove filter: ${key}`}
                              />
                            </Badge>
                          )
                        );
                      }
                      if (
                        key === "speciality" ||
                        key === "status" ||
                        key === "queue_priority" ||
                        key === "coders" ||
                        key === "queue"
                      ) {
                        return (
                          <div className="workflow-him-filter-breadcrumb-list">
                            {Array?.isArray(value) ? (
                              value.map((item, index) => (
                                <Badge
                                  key={`${key}-${index}`}
                                  bg="light"
                                  text="dark"
                                  className="workflow-him-filter-breadcrumbItem"
                                >
                                  <span>
                                    {/* {console.log(item, 'item')} */}
                                    {key.length > 0 &&
                                      key?.charAt(0)?.toUpperCase() +
                                        key?.slice(1)?.replace("_", " ")}
                                    {/* {key} */}-
                                    {/* {item.length > 0 &&
                                        item.replace(".txt", "")} */}{" "}
                                    {getValueFromApi(key, item)}
                                  </span>
                                  <span>
                                    <img
                                      src={closeIcon}
                                      height="15px"
                                      width="15px"
                                      onClick={() =>
                                        handleFilterRemove(key, item)
                                      }
                                      className="workflow-him-filter-close-icon"
                                      alt={`Remove filter: ${key}`}
                                    />
                                  </span>
                                </Badge>
                              ))
                            ) : (
                              <Badge
                                key={key}
                                bg="light"
                                text="dark"
                                className="workflow-him-filter-breadcrumbItem"
                              >
                                <span>
                                  {key?.charAt(0)?.toUpperCase() +
                                    key?.slice(1)}
                                  :
                                  {value?.includes("-")
                                    ? value?.slice(0, value?.indexOf("-"))
                                    : value}
                                </span>
                                <span>
                                  <img
                                    src={closeIcon}
                                    height="15px"
                                    width="15px"
                                    onClick={() =>
                                      handleFilterRemove(key, value)
                                    }
                                    className="workflow-him-filter-close-icon"
                                    alt={`Remove filter: ${key}`}
                                  />
                                </span>
                              </Badge>
                            )}
                          </div>
                        );
                      }
                    })}
                  </div>
                  {hasValue && (
                    <div className="workflow-filters-reset-container">
                      {" "}
                      <Button
                        onClick={handleReset}
                        className="workflow-filters-reset-btn"
                      >
                        Clear All
                      </Button>
                    </div>
                  )}
                </div>
              )}
              {/* </div> */}
              {showFilterSection && (
                <div className="workflow-him-filter-container">
                  <div className="workflow-him-filter-card">
                    <label className="workflow-him-filter-label">
                      Separation Date From
                    </label>
                    <DatePicker
                      selected={filtersPayload.separation_date_from || ""}
                      onChange={(date) => {
                        handleHimDatePickerChange("separation_date_from", date);
                      }}
                      dateFormat={dateFormat}
                      showYearDropdown
                      yearDropdownItemNumber={150}
                      scrollableYearDropdown
                      placeholderText="From"
                      className="workflow-him-filter-date-picker"
                    />
                  </div>
                  <div className="workflow-him-filter-card">
                    <label className="workflow-him-filter-label">
                      Separation Date To
                    </label>
                    <DatePicker
                      selected={filtersPayload.separation_date_to || ""}
                      onChange={(date) => {
                        handleHimDatePickerChange("separation_date_to", date);
                      }}
                      dateFormat={dateFormat}
                      showYearDropdown
                      yearDropdownItemNumber={150}
                      scrollableYearDropdown
                      placeholderText="To"
                      className="workflow-him-filter-date-picker"
                    />
                  </div>
                  <div className="workflow-him-filter-card">
                    <label
                      className="workflow-him-filter-label"
                      htmlFor="speciality"
                    >
                      Specialty/Unit
                    </label>
                    {/* <Select
                  isMulti
                  name="speciality"
                  options={HimTablefilterFieldsOptions?.speciality?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  value={getSelectedOptions("speciality")}
                  styles={customStyles}
                  className="workflow-him-filter-select"
                  placeholder="All Specialty/Unit"
                  onChange={(selectedOption) => {
                    const selectedValues = selectedOption.map(
                      (option) => option.value
                    );
                    handleHimSelectChange("speciality", selectedValues || []);
                  }}
                /> */}
                    <Dropdown className="workflow-him-filter-card-dropdown">
                      <Dropdown.Toggle
                        id="speciality"
                        className="workflow-him-filter-card-label"
                      >
                        Speciality
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="workflow-him-filter-select">
                        <div>
                          <div>
                            {!specialityLoading &&
                              specialityData?.length > 0 && (
                                <input
                                  className="workflow-him-filter-dropdown-search-input"
                                  type="text"
                                  value={specialitySearchValue}
                                  onChange={(e) =>
                                    setSpecialitySearchValue(e.target.value)
                                  }
                                  placeholder="Search"
                                />
                              )}
                          </div>
                          <div className="workflow-him-filter-dropdown-options-container">
                            {/* {renderDropdownOptions(
                            "speciality",
                            // HimTablefilterFieldsOptions?.speciality,
                            specialityData.length > 0 ? specialityData : [],
                            filterEpisodes.speciality,
                            specialitySearchValue
                          )} */}
                            {specialityLoading ? (
                              <div className="filter-loader">
                                <Spinner />
                              </div>
                            ) : (
                              specialityData?.length > 0 &&
                              specialityData
                                ?.filter((item) =>
                                  item?.speciality
                                    ?.toLowerCase()
                                    ?.includes(
                                      specialitySearchValue?.toLowerCase()
                                    )
                                )
                                ?.map((item) => (
                                  <Form.Check
                                    key={item.speciality}
                                    type="checkbox"
                                    className="workflow-him-dropdown-menu-options"
                                    label={item.speciality}
                                    value={item.speciality}
                                    checked={
                                      filtersPayload.speciality?.includes(
                                        item.speciality
                                      ) || false
                                    }
                                    onChange={() =>
                                      handleHimSelectChange(
                                        "speciality",
                                        item.speciality
                                      )
                                    }
                                  />
                                ))
                            )}
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="workflow-him-filter-card">
                    <label
                      className="workflow-him-filter-label"
                      htmlFor="queue"
                    >
                      Current Queue
                    </label>
                    {/* <Select
                  isMulti
                  name="queue"
                  options={HimTablefilterFieldsOptions?.current_queue?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  value={getSelectedOptions("queue")}
                  styles={customStyles}
                  className="workflow-him-filter-select"
                  placeholder="All Current Queue"
                  onChange={(selectedOption) => {
                    const selectedValues = selectedOption.map(
                      (option) => option.value
                    );
                    handleHimSelectChange(
                      "queue",
                      selectedValues || []
                    );
                  }}
                /> */}
                    <Dropdown className="workflow-him-filter-card-dropdown">
                      <Dropdown.Toggle
                        id="queue"
                        className="workflow-him-filter-card-label"
                      >
                        Current Queue
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="workflow-him-filter-select">
                        <div>
                          {!queueLoading && queueData?.length > 0 && (
                            <div>
                              <input
                                className="workflow-him-filter-dropdown-search-input"
                                type="text"
                                value={currentQueueSearchValue}
                                onChange={(e) =>
                                  setCurrentQueueSearchValue(e.target.value)
                                }
                                placeholder="Search"
                              />
                            </div>
                          )}
                          {/* {filteredQueues?.map((item) => (
                        <Form.Check
                          key={item}
                          type="checkbox"
                          className="workflow-him-dropdown-menu-options"
                          label={item}
                          value={item}
                          checked={filterEpisodes.queue?.includes(item)}
                          onChange={(e) =>
                            handleHimSelectChange("queue", item || [])
                          }
                        />
                      ))} */}
                          <div className="workflow-him-filter-dropdown-options-container">
                            {queueLoading ? (
                              <div className="filter-loader">
                                <Spinner />
                              </div>
                            ) : (
                              queueData?.length > 0 &&
                              queueData
                                ?.filter((item) =>
                                  item?.queue_name
                                    ?.toLowerCase()
                                    ?.includes(
                                      currentQueueSearchValue?.toLowerCase()
                                    )
                                )
                                .map((item) => (
                                  <Form.Check
                                    key={item}
                                    type="checkbox"
                                    className="workflow-him-dropdown-menu-options"
                                    label={item.queue_name}
                                    value={item.queue_id}
                                    checked={
                                      filtersPayload.queue?.includes(
                                        item.queue_id
                                      ) || false
                                    }
                                    onChange={() =>
                                      handleHimSelectChange(
                                        "queue",
                                        item.queue_id
                                      )
                                    }
                                  />
                                ))
                            )}
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="workflow-him-filter-card">
                    <label
                      className="workflow-him-filter-label"
                      htmlFor="coders"
                    >
                      Assigned Coder
                    </label>
                    {/* <Select
                  isMulti
                  name="coders"
                  options={HimTablefilterFieldsOptions?.coders?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  value={getSelectedOptions("coders")}
                  styles={customStyles}
                  className="workflow-him-filter-select"
                  placeholder="All Assigned Coder"
                  onChange={(selectedOption) => {
                    const selectedValues = selectedOption.map(
                      (option) => option.value
                    );
                    handleHimSelectChange("coders", selectedValues || []);
                  }}
                /> */}
                    <Dropdown className="workflow-him-filter-card-dropdown">
                      <Dropdown.Toggle
                        id="coders"
                        className="workflow-him-filter-card-label"
                      >
                        Assigned Coder
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="workflow-him-filter-select">
                        <div>
                          {!usersLoading && usersData.length > 0 && (
                            <div>
                              <input
                                className="workflow-him-filter-dropdown-search-input"
                                type="text"
                                value={codersSearchValue}
                                onChange={(e) =>
                                  setCodersSearchValue(e.target.value)
                                }
                                placeholder="Search"
                              />
                            </div>
                          )}
                          {/* {filteredCoders?.map((item) => (
                        <Form.Check
                          key={item}
                          type="checkbox"
                          className="workflow-him-dropdown-menu-options"
                          label={item}
                          value={item}
                          checked={filterEpisodes.coders?.includes(item)}
                          onChange={(e) =>
                            handleHimSelectChange("coders", item || [])
                          }
                        />
                      ))} */}
                          <div className="workflow-him-filter-dropdown-options-container">
                            {/* {renderDropdownOptions(
                            "coders",
                            // HimTablefilterFieldsOptions?.assigned_coder,
                            usersData?.length > 0 ? usersData : [],
                            filterEpisodes.coders,
                            codersSearchValue
                          )} */}
                            <div className="workflow-him-filter-dropdown-options-container">
                              {usersData?.length > 0 &&
                                usersData
                                  ?.filter((item) =>
                                    item.user_name
                                      ?.toLowerCase()
                                      .includes(
                                        codersSearchValue?.toLowerCase()
                                      )
                                  )
                                  .map((item) => (
                                    <Form.Check
                                      key={item}
                                      type="checkbox"
                                      className="workflow-him-dropdown-menu-options"
                                      label={item.user_name}
                                      value={item.user_id}
                                      checked={
                                        filtersPayload.coders?.includes(
                                          item.user_id
                                        ) || false
                                      }
                                      onChange={() =>
                                        handleHimSelectChange(
                                          "coders",
                                          item.user_id
                                        )
                                      }
                                    />
                                  ))}
                            </div>
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="workflow-him-filter-card">
                    <label
                      className="workflow-him-filter-label"
                      htmlFor="queue_priority"
                    >
                      Priority
                    </label>
                    {/* <Select
                  isMulti
                  name="queue_priority"
                  options={HimTablefilterFieldsOptions?.priority?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  value={getSelectedOptions("queue_priority")}
                  // value={
                  //   filterEpisodes.priority
                  //     ? {
                  //         value: filterEpisodes.priority,
                  //         label: filterEpisodes.priority,
                  //       }
                  //     : null
                  // }
                  styles={customStyles}
                  className="workflow-him-filter-select"
                  placeholder="All Priority"
                  onChange={(selectedOption) => {
                    const selectedValues = selectedOption.map(
                      (option) => option.value
                    );
                    handleHimSelectChange(
                      "queue_priority",
                      selectedValues || []
                    );
                  }}
                /> */}
                    <Dropdown className="workflow-him-filter-card-dropdown">
                      <Dropdown.Toggle
                        id="queue_priority"
                        className="workflow-him-filter-card-label"
                      >
                        Priority
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="workflow-him-filter-select">
                        <div>
                          <div>
                            <input
                              className="workflow-him-filter-dropdown-search-input"
                              type="text"
                              value={prioritySearchValue}
                              onChange={(e) =>
                                setPrioritySearchValue(e.target.value)
                              }
                              placeholder="Search"
                            />
                          </div>
                          {/* {filteredPrioritys?.map((item) => (
                        <Form.Check
                          key={item}
                          type="checkbox"
                          className="workflow-him-dropdown-menu-options"
                          label={item}
                          value={item}
                          checked={filterEpisodes.queue_priority?.includes(
                            item
                          )}
                          onChange={(e) =>
                            handleHimSelectChange(
                              "queue_priority",
                              item || []
                            )
                          }
                        />
                      ))} */}
                          <div className="workflow-him-filter-dropdown-options-container">
                            {renderDropdownOptions(
                              "queue_priority",
                              healthInsuranceManagerFiltersPriority?.length > 0
                                ? healthInsuranceManagerFiltersPriority
                                : [],
                              filtersPayload?.queue_priority,
                              prioritySearchValue
                            )}
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="workflow-him-filter-card">
                    <label
                      className="workflow-him-filter-label"
                      htmlFor="status"
                    >
                      Status
                    </label>
                    {/* <Select
                  isMulti
                  name="status"
                  options={HimTablefilterFieldsOptions?.status?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  value={getSelectedOptions("status")}
                  styles={customStyles}
                  className="workflow-him-filter-select"
                  placeholder="All Specialty/Unit"
                  onChange={(selectedOption) => {
                    const selectedValues = selectedOption.map(
                      (item) => (option) => option.value
                    );
                    handleHimSelectChange("status", selectedOption || []);
                  }}
                /> */}
                    <Dropdown className="workflow-him-filter-card-dropdown">
                      <Dropdown.Toggle
                        id="status"
                        className="workflow-him-filter-card-label"
                      >
                        Status
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="workflow-him-filter-select">
                        <div>
                          <div>
                            <input
                              className="workflow-him-filter-dropdown-search-input"
                              type="text"
                              value={statusSearchValue}
                              onChange={(e) =>
                                setStatusSearchValue(e.target.value)
                              }
                              placeholder="Search"
                            />
                          </div>
                          {/* {filteredStatus?.map((item) => (
                        <Form.Check
                          key={item}
                          type="checkbox"
                          className="workflow-him-dropdown-menu-options"
                          label={item}
                          value={item}
                          checked={filterEpisodes.status?.includes(item)}
                          onChange={(e) =>
                            handleHimSelectChange("status", item || [])
                          }
                        />
                      ))} */}
                          <div className="workflow-him-filter-dropdown-options-container">
                            {/* {renderDropdownOptions(
                            "status",
                            healthInsuranceManagerFiltersStatus?.length > 0
                              ? healthInsuranceManagerFiltersStatus
                              : [],
                              filtersPayload.status,
                            statusSearchValue
                          )} */}
                            {/* {console.log(healthInsuranceManagerFiltersStatus, 'dsdsd')} */}

                            {[
                              ...new Set(
                                healthInsuranceManagerFiltersStatus?.filter(
                                  (item) =>
                                    item
                                      ?.toLowerCase()
                                      .includes(
                                        statusSearchValue?.toLowerCase()
                                      )
                                )
                              ),
                            ].map((item) => (
                              <Form.Check
                                key={item}
                                type="checkbox"
                                className="workflow-him-dropdown-menu-options"
                                label={item}
                                value={item}
                                checked={
                                  filtersPayload.status?.includes(item) || false
                                }
                                onChange={() =>
                                  handleHimSelectChange("status", item)
                                }
                              />
                            ))}
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              )}
            </>
          </div>
          <div
            className="workflow-him-table-container"
            // style={{ overflowX: "auto" }}
          >
            <div className="workflow-him-table-header">
                {selectedHimEpisodes?.length > 0 && (
                  <Badge
                    className="workflow-him-table-td-assgine-btn"
                    onClick={() => {
                      setWorkflowHimsAssginModal(true);
                    }}
                  >
                    {selectedHimEpisodes?.some(
                      (episode) =>
                        episode?.assigned_user?.includes("Unassigned") &&
                        episode?.assigned_user?.length > 0
                    )
                      ? "Assign"
                      : "Re-assign"}
                  </Badge>
                )}
              <div className="workflow-him-table-header-right-side">
                <div className="workflow-him-table-header-search-container">
                  <img
                    src={search_icon}
                    alt="search"
                    style={{ height: "18px", paddingLeft: "5px" }}
                  />
                  <input
                    className="workflow-him-table-header-search-input"
                    value={filtersPayload.episode_identifier_search}
                    placeholder="Search episode identifer"
                    onChange={handleSearchEpisode}
                  />
                  {/* {
                episodeIdentifierSearchModal && 
                <div className="workflow-him-table-header-episode-identifer-recommendations">
                {
                  episodeIdentifierRecommendationsLoading ? 
                  <div className="workflow-him-table-header-episode-identifer-recommendations-loader">
                  <Spinner />
                </div> :  
                episodeIdentifierRecommendationsError ? <div className="workflow-him-table-header-episode-identifer-recommendations-loader">
                  <span>{episodeIdentifierRecommendationsError}</span>
                </div>
                : 
                  episodeIdentifierRecommendations?.data?.episodes?.length > 0  ? episodeIdentifierRecommendations?.data?.episodes?.map((item) => (
                    <p className="workflow-him-table-header-episode-identifer-recommendations-option" onClick={() => handleEpisodeIdentifier(item?.episode_identifier)} >EPISODE IDENTIFER: {item?.episode_identifier}</p>    
                  )) :
                  <p className="workflow-him-table-header-episode-identifer-recommendations-no-option">No Options</p>
                } 
                {                
                episodeIdentifierRecommendationsLoading && 
                <div className="workflow-him-table-header-episode-identifer-recommendations-loader">
                  <Spinner />
                </div>
              }
              </div>
              } */}
                </div>
                {selectedHimEpisodes.length > 0 ? (
                  <div className="workflow-him-selected-rows-count">
                    <Badge colorlassName="workflow-him-selected-rows-count-badge">
                      Selected Rows:
                      {isAllEpisodesSelected ? healthInsuranceManagerData?.meta?.meta?.total_episodes: selectedHimEpisodes.length}
                    </Badge>
                  </div>
                ) : (
                  <div className="workflow-him-selected-rows-count">
                    <Badge colorlassName="workflow-him-selected-rows-count-badge">
                      {/* Total Episodes: {episodesData?.length > 0 ? episodesData?.length : 0} */}
                      Total Episodes:{" "}
                      {healthInsuranceManagerData?.meta?.meta?.total_episodes
                        ? healthInsuranceManagerData?.meta?.meta?.total_episodes
                        : 0}
                    </Badge>
                  </div>
                )}
              </div>
            </div>
            <div className="workflow-him-table-body">
              <Table
                // responsive="sm"
                className="workflow-table-Hims"
                // style={{ width: healthInsuranceManagerData ? "max-content" : "" }}
                style={{ width: "100%" }}
              >
                <thead className="workflow-him-table-thead">
                  <tr className="workflow-him-table-tr">
                    <th className="workflow-him-table-th-select">
                      <input
                        type="checkbox"
                        onChange={hanldeSelectAllHimEpisodes}
                        checked={
                          uncheckedIds.length > 0
                            ? false
                            : isAllEpisodesSelected
                        }
                        className="workflow-him-table-input"
                      />
                    </th>
                    <th className="workflow-him-table-th">
                      <span>Episode Identifier</span>
                    </th>
                    <th className="workflow-him-table-th">
                      <span>Admission Date</span>
                    </th>
                    <th className="workflow-him-table-th">
                      <span>Discharge Date</span>
                    </th>
                    <th className="workflow-him-table-th">
                      <span>LOS</span>
                    </th>
                    <th className="workflow-him-table-th">
                      <span>Specialty/Unit</span>
                    </th>
                    <th className="workflow-him-table-th">
                      <span>Current Queue</span>
                    </th>
                    <th className="workflow-him-table-th">
                      <span>Assigned User</span>
                    </th>
                    <th className="workflow-him-table-th">
                      <span>Priority</span>
                    </th>
                    <th className="workflow-him-table-th">
                      <span>Status</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="workflow-him-table-body">
                  {/* {HimFilterTableData ? (
                  <td colspan="10">
                    <div className="episodelist-table-loader">
                      <Spinner />{" "}
                    </div>
                  </td>
                ) : episodesFilterListError ? (
                  <td colspan="10">
                    <div className="episodelist-table-loader1">
                      {episodesFilterListError}
                    </div>
                  </td>
                ) : dataToDisplay?.length > 0 ? ( */}
                  {healthInsuranceManagerDataLoading ? (
                    <td colspan="10">
                      <div className="workflow-him-table-loader">
                        <LdsRoller />
                      </div>
                    </td>
                  ) : healthInsuranceManagerDataError ? (
                    <td colspan="10">
                      <div className="workflow-him-table-error">
                        No data found
                      </div>
                    </td>
                  ) : dataToDisplay?.length > 0 ? (
                    dataToDisplay?.map((HimTableItem) => {
                      return (
                        <tr
                          key={HimTableItem?.hcp_line_id}
                          // style={{ borderBottom: "1px solid #E5E7EB" }}
                          draggable
                          onDragStart={(e) => handleDragStart(e, HimTableItem)}
                          className="workflow-him-table-tr"
                          // onDoubleClick={() => {
                          //   navigate("/coder");
                          //   dispatch(
                          //     resetEpisodeIdentifierTopassDocumentViewer()
                          //   );
                          //   dispatch(resetDocumentViewerLoadedData());
                          //   dispatch(selectedEpisodeList(episode));
                          //   dispatch(resetDocumentViewerError());
                          // }}
                        >
                          <td className="workflow-him-table-td">
                            <input
                              type="checkbox"
                              className="workflow-him-table-input"
                              checked={selectedHimEpisodes?.some(
                                (episode) =>
                                  episode?.hcp_line_id ===
                                  HimTableItem?.hcp_line_id
                              )}
                              onChange={(e) =>
                                handleHimRowSelection(e, HimTableItem)
                              }
                            />
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {getHighlightedText(
                                HimTableItem?.episode_identifier
                              )}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.admission_date}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.separation_date!==null ? HimTableItem?.separation_date : "-"}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.length_of_stay}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.speciality
                                ? HimTableItem?.speciality
                                : "-"}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            <Badge className="workflow-him-current_queue">
                              <div>
                                <img
                                  src={userIcon}
                                  alt=""
                                  height="15px"
                                  width="15px"
                                  className="me-2"
                                />
                              </div>
                              <div>{HimTableItem?.queue}</div>
                              <div></div>
                            </Badge>
                          </td>
                          <td className="workflow-him-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.assigned_user
                                ? HimTableItem?.assigned_user
                                : "-"}
                            </div>
                          </td>
                          <td className="workflow-him-table-td">
                            {/* {HimTableItem.Priority} */}
                            <Badge
                              className="workflow-him-priority"
                              ref={(el) => {
                                if (el) {
                                  el.style.setProperty(
                                    "background-color",
                                    HimTableItem?.priority === "URGENT"
                                      ? "#FDF2FA"
                                      : HimTableItem?.priority === "HIGH"
                                      ? "#FEF6EE"
                                      : HimTableItem?.priority === "LOW"
                                      ? "#F9FAFB"
                                      : HimTableItem?.priority === "OVERDUE"
                                      ? "#FEFCE8"
                                      : "",
                                    "important"
                                  );
                                  el.style.setProperty(
                                    "border",
                                    `1px solid ${
                                      HimTableItem?.priority === "URGENT"
                                        ? "#FCCEEE"
                                        : HimTableItem?.priority === "HIGH"
                                        ? "#F9DBAF"
                                        : HimTableItem?.priority === "LOW"
                                        ? "#EAECF0"
                                        : HimTableItem?.priority === "OVERDUE"
                                        ? "#F9DBAF"
                                        : ""
                                    }`,
                                    "important"
                                  );
                                  el.style.setProperty(
                                    "color",
                                    `${
                                      HimTableItem?.priority === "URGENT"
                                        ? "#C11574"
                                        : HimTableItem?.priority === "HIGH"
                                        ? "#D28800"
                                        : HimTableItem?.priority === "LOW"
                                        ? "#344054"
                                        : HimTableItem?.priority === "OVERDUE"
                                        ? "#344054"
                                        : ""
                                    }`,
                                    "important"
                                  );
                                }
                              }}
                              style={{
                                border: "1px solid #FCCEEE",
                                backgroundColor: HimTableItem?.PriorityColor,
                              }}
                            >
                              {HimTableItem?.priority}
                              {/* Badge Content Here */}
                            </Badge>
                          </td>
                          <td className="workflow-him-table-td">
                            {/* <Badge
                        className="workflow-him-status"
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty(
                              "background-color",
                              "#FFFF",
                              "important"
                            );
                            el.style.setProperty(
                              "border",
                              "1px solid #D0D5DD",
                              "important"
                            );
                            el.style.setProperty(
                              "color",
                              "#344054",
                              "important"
                            );
                          }
                        }}
                      >
                        <span
                          style={{
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            backgroundColor:
                              HimTableItem.status === "in_progress"
                                ? "#316BFF"
                                : HimTableItem.status === "unassigned"
                                ? "#E5E7EB"
                                : HimTableItem.status === "overdue"
                                ? "#F26724"
                                : HimTableItem.status === "uncoded"
                                ? "#478754"
                                : "#4b5563",
                            marginRight: "5px",
                            // dis
                          }}
                        ></span>
                        <span>
                          {HimTableItem.status === "in_progress"
                            ? "In Progess"
                            : HimTableItem.status === "unassigned"
                            ? "Unassigned"
                            : HimTableItem.status === "overdue"
                            ? "Overdue"
                            : HimTableItem.status === "uncoded"
                            ? "Uncoded"
                            : HimTableItem.status}
                        </span>
                      </Badge> */}
                            <Badge
                              ref={(badge) => {
                                if (badge) {
                                  // badge.style.setProperty(
                                  //   "background-color",
                                  //   episode?.status_color,
                                  //   "important"
                                  // );
                                  badge.style.setProperty(
                                    "background-color",
                                    "#FFF",
                                    "important"
                                  );
                                  badge.style.setProperty(
                                    "border",
                                    // HimTableItem?.status === "AI processing complete - codes available for validation" ? " 1px solid #4CAF50" : HimTableItem?.status === "Audited" ? "1px solid #2E7D32"  : HimTableItem?.status === "Awaiting Audit" ? "1px solid #FFA726" : HimTableItem?.status === "Awaiting CDQ" ? "1px solid #FFB300" : HimTableItem?.status === "CDQ For Review" ? "1px solid #FB8C00" : HimTableItem?.status === "Coding Complete" ? "1px solid #00897B" : HimTableItem?.status === "Locked by user" ? "1px solid #757575" : HimTableItem?.status === "Missing Notes" ? "1px solid #E53935" : HimTableItem?.status === "On Hold" ? "1px solid 6A1B9A" : HimTableItem?.status === "Outstanding" ? "1px solid #F44336" : "",
                                    // "1px solid #D0D5DD",
                                    "1px solid black",
                                    "important"
                                  );
                                  badge.style.setProperty(
                                    "color",
                                    HimTableItem?.status ===
                                      "AI processing complete - codes available for validation"
                                      ? "#4CAF50"
                                      : HimTableItem?.status === "Audited"
                                      ? "#2E7D32"
                                      : HimTableItem?.status ===
                                        "Audit - Pending CDQ"
                                      ? "#FFB300"
                                      : HimTableItem?.status ===
                                        "Audit - On Hold"
                                      ? "#BA68C8"
                                      : HimTableItem?.status ===
                                        "Audit - Awaiting Audit"
                                      ? "#FFA726"
                                      : HimTableItem?.status ===
                                        "Audit in Progress"
                                      ? "#7986CB"
                                      : HimTableItem?.status ===
                                        "Awaiting Audit"
                                      ? "#FF7043"
                                      : HimTableItem?.status === "Awaiting CDQ"
                                      ? "#AED581"
                                      : HimTableItem?.status ===
                                        "CDQ For Review"
                                      ? "#FB8C00"
                                      : HimTableItem?.status ===
                                        "Coding Complete"
                                      ? "#00897B"
                                      : HimTableItem?.status ===
                                        "Locked by user"
                                      ? "#757575"
                                      : HimTableItem?.status === "Missing Notes"
                                      ? "#E53935"
                                      : HimTableItem?.status === "On Hold"
                                      ? "#6A1B9A"
                                      : HimTableItem?.status === "Outstanding"
                                      ? "#F44336"
                                      : "black",
                                    "important"
                                    // HimTableItem?.status === "Audit - Awaiting Audit" ? "#FFA726" :
                                    // HimTableItem?.status === "AI processing complete - codes available for validation" ? " #4CAF50" : HimTableItem?.status === "Audited" ? "#2E7D32"  : HimTableItem?.status === "Audit - Awaiting Audit" ? "#FFA726" : HimTableItem?.status === "Audit - Pending CDQ" ? "#FFB300" : HimTableItem?.status === "CDQ For Review" ? "#FB8C00" : HimTableItem?.status === "Coding Complete" ? "#00897B" : HimTableItem?.status === "Locked by user" ? "#757575" : HimTableItem?.status === "Missing Notes" ? "#E53935" : HimTableItem?.status === "On Hold" ? "#6A1B9A" : HimTableItem?.status === "Outstanding" ? "#F44336" : "black",
                                    // "black",
                                  );
                                  badge.style.setProperty("display", "flex");
                                  // {episode.status === "AI processing complete - codes available for validation" ?  badge.style.setProperty("color", "white") : badge.style.setProperty("color", "#344054")}
                                  badge.style.setProperty(
                                    "align-items",
                                    "center"
                                  );
                                  badge.style.setProperty(
                                    "justify-content",
                                    "center"
                                  );
                                  badge.style.setProperty("height", "30px");
                                  badge.style.setProperty("width", "100%");
                                  // badge.style.setProperty("padding", "0px 20px");
                                  badge.style.setProperty("font-size", "12px");
                                  badge.style.setProperty(
                                    "font-weight",
                                    "800",
                                    "important"
                                  ); // Allow text to wrap
                                  badge.style.setProperty(
                                    "white-space",
                                    "normal"
                                  ); // Allow text to wrap
                                  badge.style.setProperty("overflow", "hidden"); // Hide overflowed text
                                  badge.style.setProperty(
                                    "text-overflow",
                                    "ellipsis"
                                  ); // Add ellipsis if text overflows
                                }
                              }}
                            >
                              <Tooltip title={HimTableItem?.status || "-"}>
                                {HimTableItem?.status || "-"}
                              </Tooltip>
                            </Badge>
                          </td>
                          {/* <td
                      className={`workflow-him-table-td ${
                        selectedHimEpisodes.includes(HimTableItem.medical_record_number)
                          ? "workflow-him-table-td-show"
                          : ""
                      }`}
                    >
                      {selectedHimEpisodes?.includes(
                        HimTableItem.medical_record_number
                      ) && (
                        <Badge
                          className="workflow-him-table-td-assgine-btn"
                          onClick={() => {
                            setWorkflowHimsAssginModal(true);
                            setSelectedRecord(HimTableItem);
                          }}
                        >
                          Assgin
                        </Badge>
                      )}
                    </td> */}
                        </tr>
                      );
                    })
                  ) : (
                    <td colspan="10">
                      <div className="workflow-him-table-no-records">
                        No Records Found
                      </div>
                    </td>
                  )}
                </tbody>
              </Table>
            </div>
            <div className="HimTable-footer">
              <div>
                <Pagination className="HimTable-pagination">
                  <Pagination.First className="HimTable-pagination-li"
                    onClick={() => handlePageChange(1)}
                    disabled={filtersPayload?.page_number <= 1}
                  />
                  <Pagination.Prev 
                    onClick={() =>
                      handlePageChange(filtersPayload?.page_number - 1)
                    }
                    disabled={filtersPayload?.page_number <= 1}
                    className="HimTable-prev-btn"
                  />
                  <Pagination.Item className="HimTable-pagination-li">
                    Page {filtersPayload?.page_number} of {totalPages}
                  </Pagination.Item>

                  <Pagination.Next 
                    onClick={() =>
                      handlePageChange(filtersPayload?.page_number + 1)
                    }
                    disabled={filtersPayload?.page_number >= totalPages}
                    className="HimTable-next-btn"
                  />
                  <Pagination.Last className="HimTable-pagination-li"
                    onClick={() => handlePageChange(totalPages)}
                    disabled={filtersPayload?.page_number === totalPages}
                  />
                </Pagination>
              </div>
              <div className="HimTable-row-options">
                <Form.Select
                  className="HimTable-select"
                  value={filtersPayload?.page_size}
                  onChange={handleRowsPerPageChange}
                >
                  <option
                    value=""
                    disabled
                    className="HimTable-rows-per-page_number"
                  >
                    Rows per page
                  </option>
                  {/* <option value={1} className="HimTable-rows-per-page">
                  1
                </option>
                <option value={2} className="HimTable-rows-per-page">
                  2
                </option>
                <option value={5} className="HimTable-rows-per-page">
                  5
                </option> */}
                  <option value={10} className="HimTable-rows-per-page">
                    10
                  </option>
                  <option value={20} className="HimTable-rows-per-page">
                    20
                  </option>
                  <option value={50} className="HimTable-rows-per-page">
                    50
                  </option>
                </Form.Select>
              </div>
            </div>
          </div>
        </div>
        {/* {workflowHimsAssginModal && (
        <div className="workflow-him-assign-modal-overlay-fade">
          <div className="workflow-him-assign-modal-container">
            <div className="workflow-him-assign-header">
              <p className="workflow-him-assign-header-text">
                Assign episode to:
              </p>
              <span onClick={() => setWorkflowHimsAssginModal(false)}>
                <img src={closeIcon} />
              </span>
            </div>
            <div className="workflow-him-assign-body">
              <div className="workflow-him-assign-container">
                <label className="workflow-him-assign-label">Queue </label>
                {console.log(selectedRecord.speciality, "sssss")}
                <Select
                  // isMulti
                  name="queue"
                  options={HimTablefilterFieldsOptions?.speciality?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  value={
                    selectedRecord.speciality
                      ? {
                          value: selectedRecord.speciality,
                          label: selectedRecord.speciality,
                        }
                      : null
                  }
                  // styles={customStyles}
                  // maxMenuHeight={250}
                  className="workflow-him-assign-select"
                  placeholder="queue"
                  // onChange={(selectedOption) => {
                  //   const selectedValues = selectedOption.map(
                  //     (option) => option.value
                  //   );
                  //   handleHimSelectChange("speciality", selectedValues);
                  // }}
                />
              </div>
              <p className="workflow-him-assign-divider">OR</p>
              <div className="workflow-him-assign-container">
                <label className="workflow-him-assign-label">
                  Individual Coder
                </label>
                <Select
                  // isMulti
                  name="individual_coder"
                  options={HimTablefilterFieldsOptions?.current_queue?.map(
                    (item) => ({
                      value: item,
                      label: item,
                    })
                  )}
                  // value={getSelectedOptions('speciality')}
                  // styles={customStyles}
                  // maxMenuHeight={250}
                  className="workflow-him-assign-select"
                  placeholder="queue"
                  // onChange={(selectedOption) => {
                  //   const selectedValues = selectedOption.map(
                  //     (option) => option.value
                  //   );
                  //   handleHimSelectChange("speciality", selectedValues);
                  // }}
                />
              </div>
              <div className="workflow-him-assign-footer">
                <p className="workflow-him-assign-label-section">
                  <input
                    type="checkbox"
                    checked={isEpisodeFlagged}
                    onChange={(e) => setIsEpisodeFlagged(e.target.checked)}
                  />
                  <label>Flag this episode as urgent</label>
                </p>
                <div className="workflow-him-assign-footer-btn-section">
                  <button
                    className="workflow-him-assign-cancel-btn"
                    onClick={() => setWorkflowHimsAssginModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="workflow-him-assign-confirm-btn"
                    onClick={confirmAssgineHanlder}
                  >
                    Confirm assignment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

        {workflowHimsAssginModal && (
          <HealthInformationManagerAssignModal
            workflowHimsAssginModal={workflowHimsAssginModal}
            setWorkflowHimsAssginModal={setWorkflowHimsAssginModal}
            selectedRecord={selectedRecord}
            isAllEpisodesSelected={isAllEpisodesSelected}
            selectedHimEpisodes={selectedHimEpisodes}
            handleHimSelectChange={handleHimSelectChange}
            uncheckedIds={uncheckedIds}
          />
        )}
      </div>
    </>
  );
};

export default HealthInformationManager;
